<script lang="ts">
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import StorefrontContainer from "@shared/svelte/Components/Storefront/StorefrontContainer.svelte";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

  import { params } from "@roxi/routify";
  import { onMount, onDestroy } from "svelte";

  let catalogPage: number = 1;
  let isLoading: boolean = true;
  let distributorId: number = $params.distributorId;
  let storefront;

  const pullCatalog = async params => {
    const options = {
      method: "GET",
      url: "/api/distributor/product_lines/search",
      data: {
        distributor_id: storefront.distributor_id,
        catalog_sort: storefront.catalog_sort_by,
        limit: storefront.catalog_items_per_page,
        offset: storefront.catalog_items_per_page * (catalogPage > 0 ? catalogPage - 1 : 0),
        storefront: true,
        ...params,
      },
    };
    const res = await HttpPromiseWithEntireResponse(options);

    const catalogPagination = {
      perPage: parseInt(storefront.catalog_items_per_page),
      page: catalogPage,
      totalEntries: parseInt(res.headers.get("X-Pagination-Entries")),
      goToPage: n => {
        catalogPage = n;
        pullCatalog(params);
      },
    };
    const catalog = await res.json();

    storefront = {
      ...storefront,
      catalog,
      catalogPagination,
    };
    return res;
  };

  const pullAvailableFilters = params => {
    return HttpPromise({
      method: "GET",
      url: "/api/distributor/product_lines/available_filters",
      data: {
        specified_distributor_id: distributorId,
        ...params,
      },
    });
  };

  const load = async () => {
    try {
      storefront = await HttpPromise({
        method: "GET",
        url: "api/distributor/storefronts/storefront_by_distributor_id",
        data: { distributor_id: $params.distributorId, preview: true },
      });
      pullCatalog({});
      isLoading = false;
    } catch (error) {
      window.location.href = "/404";
    }
  };

  onMount(async () => {
    await load();
    isLoading = false;
  });

  const callbacks = {
    pullCatalog,
    pullAvailableFilters,
  };

  const refreshIframe = async e => {
    const { data } = e;
    if (typeof data === "string" && data === "reload-storefront-preview") {
      await load();
    }
  };

  window.addEventListener("message", refreshIframe);

  onDestroy(() => {
    window.removeEventListener("message", refreshIframe);
  });
</script>

{#if isLoading}
  <Spinner />
{:else}
  <StorefrontContainer {storefront} {callbacks} />
{/if}
